var _g, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2585",
    "data-name": "Group 2585",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.058,
    height: 13.558,
    viewBox: "0 0 13.058 13.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_364",
    "data-name": "Ellipse 364",
    fill: "none",
    stroke: "#4c4d4a",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.25,
    fill: "none"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 3.5,
    y2: 4,
    transform: "translate(8.5 8.5)",
    fill: "none",
    stroke: "#4c4d4a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ec0e6eac19eed2bb713ee4c77051157b.svg";
export { ForwardRef as ReactComponent };